import React from "react";
// import { useTranslation } from "gatsby-plugin-react-i18next";
import { useStaticQuery, graphql } from "gatsby";
import { KuuIcon } from "../../layout/Logo";
import { Instagram, Twitter, LinkedIn, Facebook } from "@material-ui/icons";
import { BannerContainer, BannerTextContainer } from "../../Style/SellingCss";
// import { BorderedButton } from "../../Button/index";

const Banner = ({ imageComponent, paragraph }) => {
  // const { t } = useTranslation();
  const { elementBackground } = useStaticQuery(graphql`
    query {
      elementBackground: file(relativePath: { eq: "svg/GraphicBg.svg" }) {
        publicURL
      }
    }
  `);

  return (
    <>
      <BannerContainer background={elementBackground.publicURL}>
        <BannerTextContainer>
          <KuuIcon
            style={{
              maxWidth: 80,
            }}
          />

          <h1>KUU Creator</h1>
          {paragraph}
          <div
            style={{
              maxWidth: 250,
              margin: "0 auto",
              display: "flex",
              justifyContent: "space-evenly",
              color: "#4185BA",
            }}
          >
            <Instagram />
            <Twitter />
            <Facebook />
            <LinkedIn />
          </div>
          {/* <div style={{ paddingTop: "2em" }}>
            <BorderedButton
              href="#register"
              fullWidth
              style={{
                color: "#fff",
                backgroundImage: "",
                backgroundColor: "#FAB133",
                textTransform: "inherit",
                fontWeight: 700,
                textDecoration: "none",
                boxShadow: "none",
                maxWidth: 250,
                width: "100%",
                fontSize: "clamp(1rem , 2.5vw, 1.1rem)",
              }}
            >
              {t("landing.onlineSelling.register.Try for free")}
            </BorderedButton>
          </div> */}
        </BannerTextContainer>
        {imageComponent}
      </BannerContainer>
    </>
  );
};

export default Banner;
